import { useCallback, useEffect, useState, type FC } from "react";

import { AnimatePresence, m } from "motion/react";
import { nonEmptyArray } from "../../../../../utils/type-guards/general";
import LazyFramer from "../../../LazyFramer";
import type { TopBarInformationProps } from "../../TopBar";
import InformationSlide from "../InformationSlide/InformationSlide";
import * as s from "./InformationSlideShow.module.scss";

type InformationSlideProps = {
	information: TopBarInformationProps[];
};

const InformationSlideShow: FC<InformationSlideProps> = ({ information }) => {
	const [[dir, index], setTuple] = useState([0, 0]);

	const slideHandler = useCallback(() => {
		setTuple([1, index === information.length - 1 ? 0 : index + 1]);
	}, [index, information.length]);

	useEffect(() => {
		const slideTimer = setInterval(slideHandler, 4000);
		return () => clearInterval(slideTimer);
	}, [slideHandler]);

	if (!nonEmptyArray(information)) return null;

	const { _uid, icon, text, href } = information[index] ?? information[0];
	return (
		<section className={s.slideshow}>
			<LazyFramer>
				<AnimatePresence mode="wait" custom={dir}>
					<m.div
						key={_uid}
						variants={sliderVariants}
						initial="enter"
						animate="center"
						exit="exit"
						custom={dir}
						transition={{ duration: 0.2 }}
					>
						<InformationSlide icon={icon} text={text} href={href} />
					</m.div>
				</AnimatePresence>
			</LazyFramer>
		</section>
	);
};

const sliderVariants = {
	enter: (dir: number) => ({ x: dir * 100 }),
	center: { x: 0, opacity: 1 },
	exit: (dir: number) => ({ x: dir * -100, opacity: 0 }),
};

export default InformationSlideShow;
